import { ExperienceTracker } from './ExperienceTracker';

export const initExperienceTracker = () => {
  if (typeof window !== 'undefined') {
    window.__experienceTracker = ExperienceTracker;
    window.addEventListener('pagehide', () => ExperienceTracker.endAll());
  }
};
